import Swal from 'sweetalert2';

// eslint-disable-next-line
export const handleError = (error) => { Swal.fire({ title: 'エラーが発生しました。', text: error }); };
